<template>
  <div>
    <ContentHeader title="Personel List" />
    <table-skeleton v-if="loading"></table-skeleton>
    <section class="content" v-else>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header d-flex justify-content-end">
                <router-link
                  v-if="this.$route.query.is_active != undefined"
                  class="btn btn-outline-secondary mr-3"
                  :to="{ name: 'IntroducingBroker', query: {} }"
                >
                  View All
                </router-link>
                <div class="input-group input-search">
                  <input
                    type="text"
                    name="search"
                    class="form-control"
                    placeholder="Search"
                    v-model="table.filter"
                  />

                  <div class="input-group-append">
                    <button type="submit" class="btn btn-default">
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive p-0">
                <b-table
                  hover
                  :items="companyList"
                  :fields="table.fields"
                  :current-page="table.currentPage"
                  :per-page="table.perPage"
                  :filter="table.filter"
                  :filter-included-fields="['investor_name', 'level']"
                  @filtered="onFiltered"
                  show-empty
                >
                  <template #empty="scope">
                    <p class="text-center">
                      {{ scope.emptyText }}
                    </p>
                  </template>
                  <template #emptyFiltered="scope">
                    <p class="text-center">
                      {{ scope.emptyFilteredText }}
                    </p>
                  </template>
                  <template #cell(No)="data">
                    {{
                      (table.currentPage - 1) * table.perPage + data.index + 1
                    }}
                  </template>
                  <template v-slot:cell(investor_id)="data">
                    <span class="badge badge-pill badge-info">{{
                      data.item.investor_id
                    }}</span>
                  </template>
                  <template v-slot:cell(level)="data">
                    <span
                      v-if="!data.item.level"
                      class="badge badge-pill badge-danger"
                      >EMPTY LEVEL</span
                    >
                    <span
                      v-else-if="data.item.level == 'PARTNER_IB'"
                      class="badge badge-pill badge-info"
                      >Supervisor Area</span
                    >

                    <span
                      v-else-if="data.item.level == 'INTRODUCING_BROKER'"
                      class="badge badge-pill badge-warning"
                      >Agent Level</span
                    >

                    <span
                      v-else-if="data.item.level == 'MASTER_IB'"
                      class="badge badge-pill badge-success"
                      >Manager Area</span
                    >
                  </template>
                  <template v-slot:cell(is_active)="data">
                    <a href="#" @click="changeStatus(data.item.id)">
                      <span
                        v-if="data.item.is_active"
                        class="btn btn-outline-success rounded-pill"
                        >ACTIVE</span
                      >
                      <span v-else class="btn btn-outline-danger rounded-pill"
                        >NON ACTIVE</span
                      >
                    </a>
                  </template>
                  <template v-slot:cell(updated_at)="data">
                    {{ new Date(data.item.updated_at).toUTCString() }}
                  </template>
                  <template v-slot:cell(Action)="data">
                    <router-link
                      :to="{
                        name: 'IntroducingBrokerDetail',
                        params: { id: data.item.id },
                      }"
                      class="mr-3"
                    >
                      <i class="fas fa-eye"></i>
                    </router-link>
                  </template>
                </b-table>
              </div>
              <b-pagination
                v-model="table.currentPage"
                :total-rows="table.totalRows"
                :per-page="table.perPage"
                class="my-0 p-3"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
button.page-link {
  display: inline-block;
}
button.page-link {
  font-size: 20px;
  color: #29b3ed;
  font-weight: 500;
}
.offset {
  width: 500px !important;
  margin: 20px auto;
}
</style>

<script>
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import TableSkeleton from "@/components/loading-screen/TableSkeleton.vue";
import apiIB from "../../services/ApiServicesIB";

export default {
  components: {
    ContentHeader,
    TableSkeleton
  },

  created() {
    document.title = "List IB - Manager Cabang";
  },

  data() {
    return {
      loading: true,
      posts: [],
      table: {
        currentPage: 1,
        totalRows: 1,
        perPage: 10,
        filter: "",
        fields: [
          "No",
          {
            key: "investor_name",
            sortable: true,
          },
          {
            key: "level",
            sortable: false,
          },
          {
            key: "is_active",
            sortable: false,
          },
          {
            key: "updated_at",
            sortable: false,
          },
          "Action",
        ],
      },
      is_active: null,
    };
  },
  computed: {
    companyList() {
      let isActive = this.$route.query.is_active ?? "";
      if (isActive.toString().length <= 0) {
        return this.posts;
      }
      return this.posts.filter(
        (item) =>
          item.is_active.toString().toLowerCase() ==
          isActive.toString().toLowerCase()
      );
    },
  },
  async mounted() {
    try {
      let ibd = await apiIB.get(`?corporate_id=${this.$user_id}`);

      this.posts = ibd.data.data.sort(function (a, b) {
        return (
          new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
        );
      });
      this.table.totalRows = this.posts.length;
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.data.data.message,
        "error"
      );
    } finally {
      this.loading = false
    }
  },
  methods: {
    onFiltered(items) {
      this.table.totalRows = items.length;
      this.table.currentPage = 1;
    },
    changeStatus(id) {
      let status = true;
      let dataList = this.posts.find((item) => item.id == id);
      let data = new FormData();
      if (dataList.is_active == true) {
        status = false;
      } else if (dataList.is_active == false) {
        status = true;
      }
      data.append("is_active", status);

      this.$swal({
        title: "Are you sure?",
        text: "Want to change the status of this item",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Change Status",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            let res = await apiIB.put(`${id}/`, data);
            this.posts.find((item) => item.id == id).is_active =
              res.data.data.is_active;
            this.$swal("Changed!", "The Status has been Changed", "success");
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .card-header {
    flex-direction: column;
    align-items: center;
  }
  .add-button {
    width: 100%;
    margin-bottom: 0.75rem;
  }
  .input-search {
    width: 100% !important;
  }
}
.card-header {
  display: flex;
  justify-content: space-between;
}
.card-header::after {
  display: none !important;
  content: "";
}
.input-search {
  width: 250px;
}
</style>
